import axios from 'axios';
import { load } from 'recaptcha-v3';

import {
  AxiosRequestConfig,
  AxiosInstance,
  // AxiosResponse,
  AxiosError,
} from 'axios';

// import store from "./store";
// import router from "./router";

const url = process.env.VUE_APP_BASE_URL_API;

const conf: AxiosRequestConfig = {
    adapter: require('axios/lib/adapters/http'),
    baseURL: url,
    timeout: 1000 * 60 * 5, // 5 minutos
    headers: {
    'Content-type': 'application/json',
    },
};

const HTTP: AxiosInstance = axios.create(conf);

HTTP.interceptors.request.use(async (config: AxiosRequestConfig) => {
  // console.log('Interceptor de request - Iniciando...');
  // console.log('NODE_ENV:', process.env.NODE_ENV);
  // console.log('VUE_APP_RECAPTCHA_SITE_KEY:', process.env.VUE_APP_RECAPTCHA_SITE_KEY);
  // console.log('Authorization header antes:', config.headers?.Authorization);

  // CORREÇÃO: Só executa reCAPTCHA em ambiente de produção E apenas para métodos POST
  if (process.env.NODE_ENV === 'production' && 
      config.method === 'post' && 
      process.env.VUE_APP_RECAPTCHA_SITE_KEY) {
    
    // console.log('Executando reCAPTCHA...');
    
    try {
      const recaptcha = await load(process.env.VUE_APP_RECAPTCHA_SITE_KEY);
      const recaptchaToken = await recaptcha.execute('login');
      
      // CORREÇÃO: Não sobrescrever Authorization se já existir (Keycloak token)
      if (config && config.headers) {
        if (!config.headers.Authorization) {
          config.headers.Authorization = `Bearer ${recaptchaToken}`;
          // console.log('reCAPTCHA token adicionado ao Authorization header');
        } else {
          // Se já existe Authorization (Keycloak), adiciona reCAPTCHA em header separado
          config.headers['X-ReCaptcha-Token'] = recaptchaToken;
          // console.log('reCAPTCHA token adicionado ao X-ReCaptcha-Token header');
        }
      }
    } catch (error) {
      // console.error('Erro ao executar reCAPTCHA:', error);
    }
  } else {
    // console.log('reCAPTCHA pulado - ambiente:', process.env.NODE_ENV, 'método:', config.method);
  }

  // console.log('Authorization header depois:', config.headers?.Authorization);
  // console.log('Interceptor de request - Finalizado');
  
  return config;
});

HTTP.interceptors.response.use(
  (config) => config,
  (error: AxiosError) => {
    // Log do erro para debug
    // console.log('Interceptor de response - Status:', error.response?.status);
    // console.log('Interceptor de response - Error:', error);

    if (error.response && error.response.status === 403) {
      //// console.log('adm/showModalError', 'Acesso não permitido!');
      // store.dispatch("adm/showModalError", "Acesso não permitido!");
    }
    if (error.response && error.response.status === 500) {
      //// console.log('adm/showModalError', 'Servidor não responde! Tente mais tarde.');
      // store.dispatch(
      //   "adm/showModalError",
      //   "Servidor não responde! Tente mais tarde."
      // );
    }

    if ((error.response && error.response.status === 408) || error.code === 'ECONNABORTED') {
      //const message = 'Tempo excedido para obter os dados! Tente novamente.';
      //// console.log('adm/showModalError', message);
      // store.dispatch("adm/showModalError", message);
    }
    if (error.response && error.response.status === 401) {
      // Usuario nao logado
      //// console.log('adm/logout');
      // store.dispatch("adm/logout");
    }
    
    // IMPORTANTE: Para 404 e outros erros, sempre rejeitar a Promise
    // para que o código chamador possa capturar o erro
    if (error.response && error.response.status === 404) {
      // console.log('Interceptor - 404 detectado, rejeitando promise');
      return Promise.reject(error);
    }
    
    if (!error.response) {
      //// console.log('adm/showModalError', 'Falha de conexão! Tente novamente.');
      // store.dispatch(
      //   "adm/showModalError",
      //   "Falha de conexão! Tente novamente."
      // );
    }
    
    return Promise.reject(error);
  }
);

export default HTTP;